import { CLIENT_DISPATCHER_MODULE } from './constants.tsx';
import { ClientDispatcher } from './index.tsx';

let dispatcher: ClientDispatcher;

const getClientDispatcher = () => {
	if (!dispatcher) {
		dispatcher = new ClientDispatcher();
		// Handle the server hangup scenarios
		dispatcher.register(CLIENT_DISPATCHER_MODULE, dispatcher._abort.bind(dispatcher));
	}
	return dispatcher;
};

export { getClientDispatcher };
